class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindedHandleRemoveButtonClick = this.handleRemoveButtonClick.bind(this);

    this.addEventListener('click', this.bindedHandleRemoveButtonClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.bindedHandleRemoveButtonClick);
  }

  handleRemoveButtonClick(event) {
    event.preventDefault();

    const newQuantity = parseInt(this.dataset.quantity) - 1;
    const body = JSON.stringify({
      line: this.dataset.index,
      quantity: newQuantity,
      sections: ['header', 'cart-drawer'],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json`}, ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          const errors = document.getElementById('cart-errors');
          errors.textContent = response.errors;
          return;
        }

        const newCart = new DOMParser().parseFromString(response.sections["cart-drawer"], "text/html");
        document.querySelector('.cart-drawer__container').innerHTML = newCart.querySelector('.cart-drawer__container').innerHTML;

        const newHeader = new DOMParser().parseFromString(response.sections["header"], "text/html");
        document.querySelector('.header__cart').innerHTML = newHeader.querySelector('.header__cart').innerHTML;
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors');
        errors.textContent = 'Error occured while updating cart.';
      })
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cartButton = document.querySelector('.header__cart');
    this.closeCartButton = this.querySelector('.close-cart-drawer-button');
    this.cartContainer = this.querySelector('.cart-drawer__container');

    this.bindedHandleKeyUp = this.handleKeyUp.bind(this);
    this.bindedHandleClick = this.handleClick.bind(this);

    document.documentElement.style.setProperty("--cart-drawer-width", `${this.cartContainer.clientWidth}px`);

    this.cartButton.addEventListener('click', this.bindedHandleClick);
    this.addEventListener('click', this.bindedHandleClick);

    this.addEventListener('keyup', this.bindedHandleKeyUp);

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        document.documentElement.style.setProperty("--cart-drawer-width", `${entry.borderBoxSize[0].inlineSize}px`);
        this.cartContainer.style.transform = `translate(100%,${window.scrollY}px)`;
      }
    });
    this.resizeObserver.observe(this.cartContainer);
  }

  disconnectedCallback() {
    this.cartButton.removeEventListener('click', this.bindedHandleClick);
    this.removeEventListener('click', this.bindedHandleClick);
    this.removeEventListener('keyup', this.bindedHandleKeyUp);
    this.resizeObserver.disconnect();
  }

  handleKeyUp(event) {
    if (event.key !== 'Escape') return;

    this.close();
  }

  handleClick(event) {
    if (event.target.closest('.close-cart-drawer-button') || !event.target.closest('.cart-drawer__container')) {
      this.classList.contains('open')? this.close() : this.open();
    }
  }

  handleTransitionEnd() {
    this.focus();
  }

  open() {
    this.cartContainer.style.transform = `translate(100%,${window.scrollY}px)`;
    document.body.style.transform = 'translateX(calc(-1 * var(--cart-drawer-width)))';
    this.classList.add('open');
    this.cartButton.setAttribute('aria-expanded', 'true');
    this.closeCartButton.setAttribute('aria-expanded', 'true');

    this.addEventListener('transitionend', this.handleTransitionEnd.bind(this), {once: true})
  }

  close() {
    this.cartContainer.removeAttribute('style');
    document.body.removeAttribute('style');
    this.classList.remove('open');
    this.cartButton.setAttribute('aria-expanded', 'false');
    this.closeCartButton.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('cart-drawer', CartDrawer);
